import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import VideoCard from "@/components/VideoCard";
import AdSlot from "@/components/AdSlot";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "unlocked", label: "Unlocked" },
  { key: "unlock_in_progress", label: "Unlock In Progress" },
  { key: "patreon_exclusive", label: "Patreon Exclusive" },
];

export default function Videos() {
  const [params] = useSearchParams();
  const [videos, setVideos] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [filter, setFilter] = useState("all");
  const [query, setQuery] = useState(params.get("q") || "");

  useEffect(() => { setQuery(params.get("q") || ""); }, [params]);

  useEffect(() => {
    api.get("/routes").then((r) => setRoutes(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      api
        .get("/videos", { params: { status: filter, q: query || undefined, limit: 100 } })
        .then((r) => setVideos(r.data))
        .catch(() => {});
    }, 200);
    return () => clearTimeout(t);
  }, [filter, query]);

  const routeById = (id) => routes.find((r) => r.id === id);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="videos-page">
      <div className="mb-8">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#E50914] font-bold">Library</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">All Videos</h1>
        <p className="text-zinc-400 mt-2 max-w-2xl">Browse every release. Filter by status, search by title, support the goal.</p>
      </div>

      <div className="flex flex-col md:flex-row md:items-center gap-4 mb-8">
        <div className="relative flex-1 max-w-xl">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
          <input
            data-testid="video-search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search videos by title..."
            className="w-full pl-10 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 focus:border-[#E50914]/50 focus:bg-white/10 text-sm text-white placeholder:text-zinc-500 outline-none transition"
          />
        </div>
        <div className="flex flex-wrap gap-2">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key}`}
              onClick={() => setFilter(f.key)}
              className={`px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest transition-all border ${
                filter === f.key
                  ? "bg-[#E50914] border-[#E50914] text-white shadow-[0_0_20px_rgba(229,9,20,0.4)]"
                  : "bg-white/5 border-white/10 text-zinc-400 hover:text-white hover:border-white/20"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <AdSlot zoneId="5975722" className="eas6a97888e37" wrapperClassName="mb-8" />

      {videos.length === 0 ? (
        <div className="text-center py-24 text-zinc-500" data-testid="videos-empty">
          No videos found. Try a different filter or search term.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {videos.map((v) => (
            <VideoCard key={v.id} video={v} route={routeById(v.route_id)} />
          ))}
        </div>
      )}
    </div>
  );
}
